var map = {
	"./Image0.png": 65617,
	"./Image1.png": 93145,
	"./Image2.png": 61554,
	"./Image3.png": 5305,
	"./Image4.png": 44074,
	"./Image5.png": 54905,
	"./Image6.png": 60016,
	"./Image7.png": 84937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98580;